import React, { useState, useEffect } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";

const SearchComponent = ({ search, setSearch, setCurrentPage }) => {
  const [localSearch, setLocalSearch] = useState(search);

  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  const handleSearch = () => {
    setCurrentPage(1);
    setSearch(localSearch);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="form-group mb-0">
      <InputGroup>
        <Form.Control
          type="text"
          className="form-control"
          id="exampleInputText"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Cerca"
        />
        <InputGroup.Append>
          <Button variant="primary" onClick={handleSearch}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </Button>
        </InputGroup.Append>
      </InputGroup>
    </div>
  );
};

export default SearchComponent;